import API from "../axiosConfig";

export const getInfractionCoordinates = async (filters) => {
  try {
    const params = {};
    if (filters.start_date && filters.end_date) {
      params.start_date = filters.start_date;
      params.end_date = filters.end_date;
    }
    const response = await API.get("/infractions/map", { params });
    return response.data;
  } catch (error) {
    throw error;
  }
};
